// Do NOT add "use client" to this file
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";

import { PLACEHOLDER_IMAGE } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/consts";

export const getValidImageOrPlaceholder = (validImage: IImage | undefined) => {
  return validImage?.url ? validImage : PLACEHOLDER_IMAGE;
};
